import useUsersWithInitials from "./useUsersWithInitials";

const useMembersList = () => {
  const { users, ...rest } = useUsersWithInitials();
  return { users, ...rest };
};

export default useMembersList;
